<template>
  <div class="liu" v-wechat-title="'补充人脸信息'">
    <!-- Tips -->
    <div class="tips page-padding-l-r">
      <span class="txt">人脸信息</span>
    </div>
    <!-- 身份信息 -->
    <div class="color-f-bg">
      <!-- 姓名 -->
      <div class="margin-l-15">
        <div class="flex-s form-item">
          <div style="width: 95px;">姓名</div>
          <span class="label">{{ formData.idCardName }}</span>
        </div>
      </div>
      <!-- 身份证号 -->
      <div class="margin-l-15">
        <div class="line" />
        <div class="flex-s form-item">
          <div style="width: 95px;">身份证号</div>
          <span class="txt">{{ formData.idCardNum }}</span>
        </div>
      </div>
      <!-- 人脸识别 -->
      <div class="margin-l-15">
        <div class="line" />
        <div class="flex-s padding-t-10 padding-b-10">
          <div class="flex-s">
            <div style="width: 95px;">人脸识别</div>
            <div class="faceStyle" @click="onCameraImgClick('renLian')">
              <img v-if="renLian.webUrl" class="img" :src="renLian.webUrl" />
              <svg-icon v-else icon-class="camera_face" class-name="img" />
            </div>
          </div>
          <div class="btn-box">
            <div v-if="noHasHxtFaceImg" class="btn" @click="onHxtGetFaceBtnClick">
              获取人脸照片
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 提示1 -->
    <div v-if="!renLian.webUrl" class="padding-t-10 padding-b-10 page-padding-l-r title-6 say-color">
      {{ renLian.photoTips }}
    </div>
    <!-- 提示2 -->
    <div v-else class="padding-t-10 padding-b-10 page-padding-l-r title-6 say-color">
      如遇活体检测失败，可以选择
      <span class="theme-color" @click="resetCameraInfo('renLian')">重新识别</span>或
      <span class="theme-color" @click="jumpManualAudit">申请人工审核</span>
    </div>
    <!-- 提交按钮 -->
    <div class="margin-t-20 padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" :disabled="submitBtnDisabled" @click="onSubmitBtnClick">提交</mt-button>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';
import { formatDateLongStr } from '@/utils/utils';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { YMTivingThing, GetPersonFaceVerifyMsg, PersonFaceVerify, UpdateIdCardInfoFaceActive } from '@/api/weChat';
import { GetHXTLivenessDetectionUrl, QueryHXTLivenessDetectionResult, InitALiFaceVerify } from '@/api/faceVerify';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'LiveFaceOne',
  components: { SvgIcon },
  data() {
    return {
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        popupVisible: false,
        photoTips: PUBLIC_FACE_PHOTO_TIPS,
      },
      // 表单数据
      formData: {
        idCardName: "",
        idCardNum: "",
      },
      // 身份证识别批次号 2023.4.23
      idCardBatchNo: '',
      // 提交按钮可否点击状态 2026.8
      submitBtnDisabled: true
    };
  },
  computed: {
    noHasHxtFaceImg() {
      return this.faceDetectActivity === 5 && this.renLian.webUrl && this.renLian.webUrl.indexOf("jpeg") === -1
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.fromh5faceflag) {
        // 从H5人脸跳回来，从localStorage取数据
        this.readDataByLocalStorage(this.$route.query.fromh5faceflag);
      } else {
        // 反之，则直接从url中取数据
        this.readDataByRouteQuery();
      }
    });
  },
  methods: {
    // 2026.7 读取LocalStorage中数据给页面变量赋值
    readDataByLocalStorage(fromFlag) {
      // 获取localStorage中存储的url参数
      const paramStr = localStorage.getItem("h5Face_urlParam");

      // 获取参数值的函数
      const getParamValue = (search, paramName) => {
        const obj = {};
        const arr = search.split('&');
        for (let i = 0, newArr = []; i < arr.length; i++) {
          newArr = arr[i].split('=');
          if (typeof obj[newArr[0]] === 'undefined') { obj[newArr[0]] = newArr[1]; }
        }
        return obj[paramName] || '';
      }

      // 强制按钮状态为2
      this.submitBtnDisabled = false;

      // 给变量赋值
      this.faceDetectActivity = parseInt(getParamValue(paramStr, "facedetectactivity"));
      this.idCardBatchNo = getParamValue(paramStr, "idcardbatchno");
      this.formData.idCardName = decodeURIComponent(getParamValue(paramStr, "idcardname"));
      this.formData.idCardNum = getParamValue(paramStr, "idcardnum");

      // 因小程序webview跳转阿里人脸h5成功后再回跳回当前页面后无法调用接口
      // 所以改为给小程序发消息，用小程序调用接口，来查询人脸结果
      let data = null;
      if (fromFlag === 'h') {
        data = this.createPostMessage("hXtH5Face");
        wx.miniProgram.postMessage({ data });
        wx.miniProgram.redirectTo({
          url: '/pages/media/media',
        });
      } else {
        data = this.createPostMessage("aLiH5Face");
        wx.miniProgram.postMessage({ data });
        wx.miniProgram.redirectTo({
          url: '/pages/media/media',
        });
      }
    },
    // 2026.7 读取route.query中数据给页面变量赋值
    readDataByRouteQuery() {
      // 通过接口获取用户基本信息
      this.getPersonFaceVerifyMsg(res => {
        this.formData.idCardName = res.data.idCardName;
        this.formData.idCardNum = res.data.idCardNum;
        this.faceDetectActivity = parseInt(this.$route.query.facedetectactivity);
        this.idCardBatchNo = `${formatDateLongStr(new Date())}${String(Math.floor(Math.random() * 9000000000000 + 1000000000000))}`;
        const imgType = this.$route.query.imgtype;
        if (imgType) {
          this.idCardBatchNo = this.$route.query.idcardbatchno;
          this.renLian.webUrl = decodeURIComponent(this.$route.query.rlweburl).replace('|', '?');
          switch (imgType) {
            case 'ymt':
              if (this.renLian.webUrl) {
                this.yMTivingThing();
              }
              break;
            case 'aLiH5Face':
              if (this.renLian.webUrl) {
                this.submitBtnDisabled = false;
              }
              break;
            case 'hXtH5Face':
              // 恒信通的人脸照片有延迟，需要判断是否有照片
              if (this.renLian.webUrl.indexOf("jpeg") > -1) {
                this.submitBtnDisabled = false;
              } else {
                this.queryHXTLivenessDetectionResult(() => {
                  if (this.renLian.webUrl.indexOf("jpeg") > -1) {
                    this.submitBtnDisabled = false;
                  }
                });
              }
              // // 将传回的h5人脸网络图片转成base64编码，再上传到图片服务器
              // // 获取手机号
              // const mobile = this.$route.query.mobile;
              // // 转换格式
              // this.convertImageToBase64(this.renLian.webUrl, base64Data => {
              //   // CusAlert(base64Data);
              //   // 上传base64到图片服务器
              //   upLoadImg("", base64Data, "renLian", mobile, yes => {
              //     // 成功后取图片服务器上的照片并赋值
              //     this.renLian.webUrl = yes.data;
              //   }, no => {
              //     // 失败提示重新做人脸
              //     this.resetCameraInfo('renLian', 2);
              //   });
              // });
              break;
          }
        }
      });
    },
    // 调用云码通的接口做人脸识别
    yMTivingThing() {
      CusLoadingOpen();
      YMTivingThing({ url: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            this.renLian.webUrl = this.renLian.webUrl;
            this.renLian.fileUrl = this.renLian.webUrl;
            this.renLian.base64 = this.renLian.webUrl;
            this.submitBtnDisabled = false;
          }, (code, msg) => {
            if (msg) {
              CusAlert(msg, () => {
                this.renLian.webUrl = "";
                this.renLian.fileUrl = "";
                this.renLian.base64 = "";
                this.submitBtnDisabled = true;
              });
            }
          });
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case 'renLian':
          this.jumpToLiveness();
          break;
      }
    },
    // 人脸识别不同方式不同处理
    jumpToLiveness() {
      let data = null;
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          data = this.createPostMessage('renLian');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          CusAlert('尚未开百度人脸识别服务，请更换其他服务');
          break;
        case 3: // 云码通
          data = this.createPostMessage('ymt');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 4: // 2026.7.21 阿里
          this.initALiFaceVerify();
          break;
        case 5:  // 2026.7.21 恒信通
          this.getHXTLivenessDetectionUrl();
          break;
      }
    },
    // 2026.7 调用接口使用恒信通H5人脸活体
    getHXTLivenessDetectionUrl() {
      CusLoadingOpen();
      // ***向url中添加参数，作为当前页面onLoad后自动调用接口的标识*** //
      // ①.获取url
      const url = window.location.href;
      // ②.获取url参数对象
      const urlParams = new URLSearchParams(url.split('?')[1]);
      // ③.设置参数值
      urlParams.set("idcardbatchno", this.idCardBatchNo);
      urlParams.set("idcardname", this.formData.idCardName);
      urlParams.set("idcardnum", this.formData.idCardNum);
      // ④.将设置好的url参数存入localStorage中
      localStorage.setItem("h5Face_urlParam", urlParams.toString());
      // ⑤.将域名和标识组成新的url当做接口入参
      const newUrl = `${url.split('?')[0]}?fromh5faceflag=h`;
      // ************************************************************************************ //
      GetHXTLivenessDetectionUrl({
        callBackUrl: newUrl,
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            // 将返回数据集中的certifyId存入localStorage中，作为回调后查询结果的key
            localStorage.setItem("h5Face_certifyId", res.data.order_no);
            // 由于获取人脸成功后的图片是异步的，所以有没有return_url情况
            if (res.data.return_url) {
              // 有return_url直接跳转
              window.location.href = res.data.return_url;
            } else {
              // 反正，则直接调查询结果接口
              this.queryHXTLivenessDetectionResult();
            }
          }, (code, msg) => {
            if (msg) {
              CusAlert(msg, () => {
                if (msg.indexOf("已完成") > -1) {
                  this.queryHXTLivenessDetectionResult(() => {
                    if (this.renLian.webUrl.indexOf("jpeg") > -1) {
                      this.submitBtnDisabled = false;
                    }
                  });
                }
              });
            }
          });
        })
        .catch(err => {
          CusLoadingClose();
          const message = NotSucceedHandle(err.message);
          if (message) {
            CusToast(message);
          }
        });
    },
    // 2026.7 调用接口使用阿里H5人脸活体
    initALiFaceVerify() {
      CusLoadingOpen();
      // ***向url中添加参数，作为当前页面onLoad后自动调用接口的标识*** //
      // ①.获取url
      const url = window.location.href;
      // ②.获取url参数对象
      const urlParams = new URLSearchParams(url.split('?')[1]);
      // ③.设置参数值
      urlParams.set("idcardbatchno", this.idCardBatchNo);
      urlParams.set("idcardname", this.formData.idCardName);
      urlParams.set("idcardnum", this.formData.idCardNum);
      // ④.将设置好的url参数存入localStorage中
      localStorage.setItem("h5Face_urlParam", urlParams.toString());
      // ⑤.将域名和标识组成新的url当做接口入参
      const newUrl = `${url.split('?')[0]}?fromh5faceflag=a`;
      // ************************************************************************************ //
      InitALiFaceVerify({
        returnUrl: newUrl,
        metaInfo: JSON.stringify(window.getMetaInfo())
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            // 将返回数据集中的certifyId存入localStorage中，作为回调后查询结果的key
            localStorage.setItem("h5Face_certifyId", res.data.certifyId);
            window.location.href = res.data.certifyUrl;
          }, (code, msg) => {
            if (msg) {
              CusAlert(msg, () => {
                // CusAlert(`入参：${newUrl}；${JSON.stringify(window.getMetaInfo())}，结果：${JSON.stringify(res)}`);
                return;
              });
            }
          });
        })
        .catch(err => {
          CusLoadingClose();
          const message = NotSucceedHandle(err.message);
          if (message) {
            CusToast(message);
          }
        });
    },
    // 2026.7 调用接口查询恒信通H5人脸活体接口
    queryHXTLivenessDetectionResult(callback = null) {
      CusLoadingOpen();
      QueryHXTLivenessDetectionResult({
        order_no: localStorage.getItem("h5Face_certifyId")
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            this.renLian.webUrl = res.data.livingImgUrl;
            callback && callback();
          }, (code, msg) => {
            if (msg) {
              CusAlert(msg, () => { return });
            }
          });
        })
        .catch(err => {
          CusLoadingClose();
          const message = NotSucceedHandle(err.message);
          if (message) {
            CusToast(message);
          }
        });
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'LiveFaceOne',
        imgType: imgTypeStr,
        idCardBatchNo: this.idCardBatchNo,
        rlWebUrl: encodeURIComponent(this.renLian.webUrl.replace('?', '|')),
        h5faceCertifyId: localStorage.getItem("h5Face_certifyId") || '',
      };
    },
    // 调用获取公安比对信息
    getPersonFaceVerifyMsg(callback = null) {
      CusLoadingOpen();
      GetPersonFaceVerifyMsg({})
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            callback && callback(res);
          }, () => {
            callback && callback();
          });
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口上传人脸照片
    updateIdCardInfoFaceActive(url, callback = null) {
      CusLoadingOpen();
      UpdateIdCardInfoFaceActive({ url, batchNumber: this.idCardBatchNo })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            callback && callback();
          }, () => {
            callback && callback();
          });
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      if (name === 'renLian') {
        this[name].photoTips = PUBLIC_FACE_PHOTO_TIPS
      }
    },
    // 跳人工审核
    jumpManualAudit() {
      if (!this.renLian.webUrl) {
        CusToast('请先进行人脸识别');
        return;
      }
      this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
        CusAlert('已为您申请人工审核，预计将在1个工作日内完成。请继续完成后续认证流程，否则将无法通过人工审核', () => {
          this.replacePage('auth/manualreview', { idcardname: this.formData.idCardName, bankcardstatus: 1 });
        });
      });
    },
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case 'renLian':
          this.jumpToLiveness();
          break;
      }
    },
    // 提交按钮点击事件
    onSubmitBtnClick() {
      CusLoadingOpen();
      PersonFaceVerify({ faceUrl: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg,
            () => {
              CusAlert(res.data.Msg, () => {
                this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
                  // 向小程序发消息，更新状态
                  wx.miniProgram.postMessage({ data: { page: 'refresh' } });
                  wx.miniProgram.navigateBack();
                });
              });
            },
            (code, msg) => {
              if (res.innerCode === 7776) {
                CusAlert(msg, () => {
                  this.replacePage('auth/manualreview', { idcardname: this.formData.idCardName, bankcardstatus: 1 });
                });
              } else {
                if (msg) {
                  CusAlert(msg, () => {
                    this.renLian.webUrl = "";
                    this.renLian.fileUrl = "";
                    this.renLian.base64 = "";
                    this.submitBtnDisabled = true;
                  });
                }
              }
            });
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 恒信通获取人脸照片按钮点击事件
    onHxtGetFaceBtnClick() {
      this.queryHXTLivenessDetectionResult(() => {
        if (this.renLian.webUrl.indexOf("jpeg") > -1) {
          this.submitBtnDisabled = false;
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.tips {
  line-height: 1;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  .txt {
    font-size: $title5;
    color: $explain-color;

    .red {
      color: red;
    }
  }
}

.line {
  height: 1px;
  border-bottom: 1px solid $border-color;
}

.form-item {
  line-height: 1;
  padding: 0.6rem 0;

  .label {
    font-size: $title3;
    color: $word-color;
  }

  .txt {
    font-size: $title3;
    color: $explain-color;
  }
}

.btn-box {
  width: 100%;
  height: 6.3rem;
  line-height: 1;
  position: relative;

  .btn {
    border: 1px solid;
    @include dynamic-border-color;
    @include dynamic-color;
    padding: 0.25rem;
    border-radius: 0.3rem;
    position: absolute;
    left: 0.4rem;
    bottom: 0;
  }
}
</style>